import PropTypes from 'prop-types';
import React from 'react';

import { propTypesHeaderSection } from '../Header.proptypes';

import Icon, { IconSize } from '../../../../../ui/Atoms/Icon';

import { getIcon } from '../../../../utils/getIcon';

import * as S from './HeaderSection.styles';

export const HeaderSection = ({ section, hasMoreButton }) => {
  const { section: { document: { data } = {} } = {} } = section || {};
  const {
    section_title: { text: title } = {},
    section_color: color,
    links,
  } = data || '';

  const hasAdditionalPadding = !hasMoreButton && !!title;

  if (!links.length) {
    return null;
  }

  return (
    <S.Section hasAdditionalPadding={hasAdditionalPadding}>
      {title && <S.SectionLabel>{title}</S.SectionLabel>}
      {links.map((link, index) => {
        const { header_link: { document: { data: linkData } = {} } = {} } =
          link || {};

        const {
          link_label: { text: linkLabel } = {},
          link_url: { url: linkUrl, target: linkTarget } = {},
          link_icon: linkIcon,
          link_description: linkDescription,
        } = linkData || '';

        if (!linkUrl || !linkLabel) {
          return null;
        }

        return (
          <S.HeaderLink
            href={linkUrl}
            target={linkTarget}
            title={linkLabel}
            key={`${link}-${index}`}
            onMouseDown={e => {
              e.preventDefault();
              // Force navigation on mouse down in order to fix issues we have with Safari on desktop
              // when clicking on links the redirection was not made.
              if (linkTarget === '_blank') {
                window.open(linkUrl, '_blank');
              } else {
                window.location.href = linkUrl;
              }
            }}
          >
            {linkIcon && (
              <Icon customColor={color} size={IconSize.MICRO}>
                {getIcon(linkIcon)}
              </Icon>
            )}
            <S.LinkWrapper>
              {linkLabel && <S.LinkLabel>{linkLabel}</S.LinkLabel>}
              {linkDescription && (
                <S.LinkDescription>{linkDescription}</S.LinkDescription>
              )}
            </S.LinkWrapper>
          </S.HeaderLink>
        );
      })}
    </S.Section>
  );
};

HeaderSection.propTypes = {
  /**
   * HeaderSection document from Prismic.
   */
  section: PropTypes.shape(propTypesHeaderSection),
  /**
   * If hasMoreButton = true, adapt the padding of
   * the section in order to display the optional CTA.
   */
  hasMoreButton: PropTypes.bool,
};
